import { useContext, useEffect } from 'react';
import { Context as RestaurantContext } from '../context/restaurant';

export function useTableSseConnection() {
  const { state: restaurantState, tryOpenTableSseHandler } = useContext(RestaurantContext);

  useEffect(() => {
    tryOpenTableSseHandler();
  }, [restaurantState.table]);
}
